// @components
import { Button, Form, Input, Radio } from 'antd';
import Context from 'context/appContext';
import { RichText } from 'prismic-reactjs';
import React, { useState } from 'react';
import { useContext } from 'react';
import moment from 'moment';
import { getInfoField, setFieldsValue, validateForm } from 'utils/utils';
import ReactPlayer from 'react-player'

// @styles 
import './styles.scss'
import { Bounce, Fade } from "react-reveal";

export default function Banner({ data: dataPrismic, validate, isLoading }) {
    const [form] = Form.useForm();
    const info = dataPrismic.primary
    const [values, setValues] = useState({});
    const { dataForm: { data, formResponses } } = useContext(Context);
    const momentT = require("moment-timezone");

    const typeIdProperty = {
        'Propia': 1,
        'Rentada': 2,
        'Propia y Rentada': 3
    }
    const typeIdPropertyBody = {
        '1': 'Propio',
        '2': 'Renta',
        '3': 'Arrendatario'
    }

    const onChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        const field = {
            key: name === 'cp' ? 'codigoPostal' : 'tipoInmueble',
            value: value,
        }
        field['label'] = typeIdPropertyBody[field.value];
        field['name'] = dataPrismic && dataPrismic.items && dataPrismic.items.find(x => x.itemkey === field.value)?.itemlabel;
        const indexField = formResponses.findIndex(x => x.key === field.key);
        indexField !== -1 ? formResponses[indexField] = field : formResponses.push(field);
        setValues({ ...values, [e.target.name]: e.target.value });
        if (field && field.value && field.value !== '3') { field.label && setValueInitial(); }
    };

    const setValueInitial = () => {
        const allComponents = data && data.formDefinition && data.formDefinition.components;
        const format = 'YYYY-MM-DD';
        let today = momentT().tz("America/Mexico_City").format("YYYY-MM-DD");
        const hour = momentT().tz("America/Mexico_City").format("HH");

        if (hour >= 12) {
            today = moment(today).add(1, "days").format("YYYY-MM-DD");
        }
        const onYearLater = moment(today, format).add(1, 'year').format(format);
        setFieldsValue('hasFireAlarm', false, null, formResponses);
        setFieldsValue('hasSecurityAlarm', false, null, formResponses);
        setFieldsValue('optionalCoverages', [], null, formResponses);
        setFieldsValue('vigenciaPolizaDesde', today, getInfoField('vigenciaPolizaDesde', 'step_emision_vigencia_poliza', allComponents), formResponses);
        setFieldsValue('vigenciaPolizaHasta', onYearLater, getInfoField('vigenciaPolizaHasta', 'step_emision_vigencia_poliza', allComponents), formResponses);
    }

    return info && (
        <div className='banner__container' id={info.idcontent}>
            <Fade bottom cascade delay={0.3}>
                <div className='container-xl'>
                    <div className='banner__container-text'>
                        <div className='banner__container-img'>
                            {info.image && info.image.url ?
                                <img
                                    src={info.image && info.image.url ? info.image.url : ""}
                                    alt={info?.image?.alt}
                                />
                                :
                                <ReactPlayer
                                    url={info.video && info.video.url ? info.video.url : ""}
                                    playing={true}
                                    loop={true}
                                    muted
                                />
                            }
                        </div>
                        {info.sectiontitle && (
                            <div className='banner__container-text-title'>
                                <RichText
                                    render={info.sectiontitle}
                                />

                            </div>
                        )}
                    </div>
                    <div className='banner__container-sider'>
                        <div className='banner__container-sider-item-header'>
                            <p>{info.sidecontenttitle}</p>
                        </div>
                        <div className='banner__container-sider-item'>
                            <div className='banner__container-sider-item-info'>
                                <Form
                                    form={form}
                                >
                                    <Form.Item
                                        label={info.sidecontentlabelinput}
                                        name="cp"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Este campo es requerido"
                                            },
                                            {
                                                pattern: new RegExp("^([0-9]*)$"),
                                                message: "Ingrese un código postal valido"
                                            },
                                            {
                                                min: 5,
                                                max: 5,
                                                message: "Mínimo 5 caracteres"
                                            }
                                        ]}
                                    >
                                        <Input
                                            name="cp"
                                            placeholder="00000"
                                            autoComplete={true}
                                            minLength={5}
                                            maxLength={5}
                                            onChange={onChange}
                                            onBlur={onChange}
                                        />
                                    </Form.Item>
                                    <div className='banner__container-text-description'>
                                        <RichText
                                            render={info.sidecontentdescription}
                                        />
                                    </div>
                                    <Form.Item
                                        className='ant-form-item-normal'
                                        name="typeProperty"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Este campo es requerido"
                                            }
                                        ]}
                                    >
                                        <Radio.Group
                                            className='radiobutton-custom'
                                            disabled={isLoading}
                                            onChange={onChange}
                                            name="typeProperty"
                                        >
                                            {dataPrismic && dataPrismic.items.map((item) => {
                                                return item && (<Radio
                                                    className="radiobutton-custom__item"
                                                    value={item.itemkey}
                                                >
                                                    {item && item.itemimage && item.itemimage.url &&
                                                        (<img src={item.itemimage.url} alt={item.itemlabel} />)}
                                                    <p>{item.itemlabel}</p>
                                                </Radio>)
                                            }
                                            )}
                                        </Radio.Group>
                                    </Form.Item>
                                </Form>
                            </div>
                        </div>
                        {info.buttonname && (
                            <Bounce delay={8}>
                                <Button
                                    className='ant-btn-solid c-3 ant-btn-size-xs'
                                    onClick={async () => {
                                        await validateForm(['cp', 'typeProperty'], form) && validate(values)
                                    }}
                                    loading={isLoading}
                                    data-testId={info.buttonname}
                                >
                                    <div>{info.buttonname}</div>
                                </Button>
                            </Bounce>
                        )}
                    </div>
                </div>
            </Fade>
        </div >
    )
}